import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { getOnGoingActivity } from 'modules/serendipity/actions';
import OngoingActivity from '../components';


function mapStateToProps(state) {
  return {
    app: state.app,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getOnGoingActivity: bindActionCreators(getOnGoingActivity, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OngoingActivity));



// WEBPACK FOOTER //
// ./src/components/OngoingActivity/container/index.js